import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base/Base';
import { Interactive } from '../../Base/Interactive/Interactive';
import Svg from '../../Svg';
import { Icon, Widget } from '../../Widget';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Product-root_3IDUL",
  "icon": "Product-icon_8mzgy",
  "wrapper": "Product-wrapper_1uYqV",
  "link": "Product-link_VaoP7",
  "popoverIcon": "Product-popoverIcon_a76Pc"
};
function renderPopoverIcon(popoverIcon) {
  if (Array.isArray(popoverIcon)) {
    return popoverIcon.map(ppvrcn => renderPopoverIcon(ppvrcn));
  }
  if (popoverIcon && /*#__PURE__*/React.isValidElement(popoverIcon)) {
    return /*#__PURE__*/React.cloneElement(popoverIcon, {
      className: styles.popoverIcon
    });
  }
  return null;
}
function Product({
  to,
  href,
  as = 'h4',
  icon,
  iconTheme,
  title,
  subtitle,
  className,
  popoverIcon,
  onClick,
  ...extraProps
}) {
  const hasIcon = icon && Svg.has(icon);
  const hasLink = typeof to === 'string' || typeof href === 'string';
  return /*#__PURE__*/_jsxs(Widget, {
    tagName: "article",
    flex: true,
    paddingLeft: "small",
    paddingRight: popoverIcon ? null : 'xsmall',
    widgetFluidHeight: true,
    className: clsx(styles.root, className),
    ...extraProps,
    children: [icon && hasIcon && /*#__PURE__*/_jsx(Icon, {
      name: icon,
      theme: iconTheme,
      paddingRight: "xsmall",
      widgetFluidHeight: false,
      className: styles.icon
    }), /*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexCol: true,
      flexJustifyCenter: true,
      className: styles.wrapper,
      children: [/*#__PURE__*/_jsx(Base, {
        tagName: as,
        size: "base",
        weight: "semibold",
        margin: "none",
        children: hasLink ? /*#__PURE__*/_jsx(Interactive, {
          to: to,
          href: href,
          onClick: onClick,
          className: styles.link,
          children: title
        }) : title
      }), subtitle && /*#__PURE__*/_jsx(Base, {
        tagName: "p",
        size: "small",
        color: "light",
        margin: "none",
        children: subtitle
      })]
    }), popoverIcon && /*#__PURE__*/_jsx(Base, {
      flex: true,
      paddingX: "xsmall",
      children: renderPopoverIcon(popoverIcon)
    })]
  });
}
export default Product;